export const ASOCIACION_CONSTANTS = {
  DIALOG_CONFIG: {
    MAX_WIDTH: 'md' as const,
    DEFAULT_TITLE: 'Editar Asociación',
  },

  FIELD_LABELS: {
    descripcion: 'Descripción *',
    idProcedencia: 'Procedencia *',
  },
} as const;